// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import HappyTail from './HappyTail'

class HappyTails extends React.Component {
	render() {
		const { happyTailsById } = this.props
		let markup = ''

		if ( happyTailsById && Object.keys( happyTailsById ).length ) {
			markup = Object.keys( happyTailsById )
				.map( key => {
					let item = happyTailsById[ key ]

					return (
						<HappyTail
							key={ item.id }
							title={ item.title }
							imageUrl={ item.image_url }
							imageGallery={ item.image_gallery }
							content={ item.content }
						/>
					)
				})
		}

		return (
			<div className="happy-tails page-section">
				<div className="-inner">
					{ markup }
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		happyTailsById: state.animals.happyTailsById
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( HappyTails )



// WEBPACK FOOTER //
// ./views/main/page/HappyTails.jsx